"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropsTypes = require("prop-types");
var util_1 = require("./util");
/**
 * Render components based on the state of a promise. Renders `then` prop when the promise is resolved.
 * Renders `catch` prop when the promise is rejected. Renders `placeholder` while the promise is not
 * resolved nor rejected.
 */
var Await = /** @class */ (function (_super) {
    __extends(Await, _super);
    function Await(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            status: 0 /* AWAITING */,
            value: void 0,
            failReason: void 0
        };
        return _this;
    }
    Await.prototype.componentDidMount = function () {
        var _this = this;
        this.props.promise.then(function (value) {
            _this.setState({ status: 1 /* SUCCESS */, value: value });
        }, function (reason) {
            _this.setState({ status: 2 /* FAILED */, failReason: reason });
        });
    };
    Await.prototype.render = function () {
        switch (this.state.status) {
            case 0 /* AWAITING */:
                return util_1.toElement(this.props.placeholder);
            case 1 /* SUCCESS */:
                return util_1.toElement(this.props.then, this.state.value);
            case 2 /* FAILED */:
                return util_1.toElement(this.props.catch, this.state.failReason);
        }
        return null;
    };
    return Await;
}(React.Component));
exports.Await = Await;
Await.propTypes = {
    promise: PropsTypes.any.isRequired,
    then: PropsTypes.any.isRequired,
    placeholder: PropsTypes.any,
    catch: PropsTypes.any
};
//# sourceMappingURL=await.js.map